import React, { useEffect } from 'react';
import { Route, Redirect, Switch, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import SiLogin from './pages/user/SiLogin';
import Estimate from './pages/es/Estimate';
import EsApply from './pages/es/EsApply';
import SuSignup from './pages/user/SuSignup';
import { Helmet } from 'react-helmet-async';
import Category from './pages/ct/Category';
import MySetting from './pages/mp/MySetting';
import ProductDetail from './pages/pd/ProductDetail';
import ProductDetail2 from './pages/pd/ProductDetail2';
import SrMyCart from './pages/user/SrMyCart';
import SpaceMain from './pages/st/SpaceMain';
import ErrorMain from './pages/cs/ErrorMain';
import BrandMain from './pages/br/BrandMain';
import BrandHome from './pages/br/BrandHome';
import SiResetPasswd from './pages/user/SiResetPasswd';
import SiFindId from './pages/user/SiFindId';
import SpaceDetail from './pages/st/SpaceDetail';
import ConsultMain from './pages/cs/ConsultMain';
import MyQuestion from './pages/mp/MyQuestion';
import NoticeMain from './pages/cs/NoticeMain';
import FaqMain from './pages/cs/FaqMain';
import SearchMain from './pages/search/SearchMain';
import SearchProd from './pages/search/SearchProd';
import MyClip from './pages/mp/MyClip';
import EsOrder from './pages/od/EsOrder';
import EsOrderDone from './pages/od/EsOrderDone';
import SiInfo from './pages/user/SiInfo';
import ReactGA from 'react-ga';
import MyDrop from './pages/mp/MyDrop';
import CampaignHome from './pages/campaign/CampaignHome';
import EventDetail from './pages/campaign/EventDetail';
import EventMain from './pages/campaign/EventMain';
import RequestForm from './pages/user/RequestForm';
import EstimateInfoView from './pages/es/EstimateInfoView';
import EstimateDoneInfoView from './pages/es/EstimateDoneInfoView';
import EsOrderMulti from './pages/od/EsOrderMulti';
import EsOrderDoneMulti from './pages/od/EsOrderDoneMulti';
import EstimateStep1 from './pages/es/EstimateStep1';
import EstimateStep2 from './pages/es/EstimateStep2';
import EstimateStep3 from './pages/es/EstimateStep3';
import EstimateStep4 from './pages/es/EstimateStep4';
import EstimateStep5 from './pages/es/EstimateStep5';
// import GlobalStyle from './components/style/GlobalStyle';
import { useHistory } from 'react-router-dom';
import {logging} from './lib/util/CommonFunctions';

import {isTablet} from 'react-device-detect';
import TagManager from 'react-gtm-module';

const App = () => {

    const location = useLocation();
    const history = useHistory();
    logging(location)
    useEffect(() => {
        if(location.pathname.includes("/search")) return;
        TagManager.initialize({
              gtmId: process.env.REACT_APP_GTM,
              auth: process.env.REACT_APP_GTM_AUTH,
              preview: process.env.REACT_APP_GTM_PREVIEW
          });
        // ReactGA.initialize(process.env.REACT_APP_GA);
        // ReactGA.set({ page: location.pathname });
        // ReactGA.pageview(location.pathname);
        window.scrollTo(0, 0); // #2670 - 페이지 이동시 스크롤 위치 조정
    }, [location.pathname]);

    return (
        <>
            <Helmet>
                {/* commented out temporarily before ssr implementation JP */}
                {/*<meta charSet="utf-8"/>*/}
                {/*<meta httpEquiv="x-ua-compatible" content="ie=edge" />*/}

                <title>어디가구</title>
                {isTablet&&<meta name="viewport" content="width=1231,zoom: 1.0 ;" />}
                {/*<meta name="title" content="어디가구" />*/}
                {/*<meta name="description" content="비용 없는 가구 견적 서비스. 우리가 원하는 신혼가구, 침실가구, 거실가구, 오피스 가구 만 고르고 견적받으세요!" />*/}
                {/*<meta property="og:type" content="website"/>*/}
                {/*<meta property="og:url" content="https://www.odgagu.co.kr"/>*/}
                {/*<meta property="og:title" content="어디가구"/>*/}
                {/*<meta property="og:description" content="비용 없는 가구 견적 서비스. 우리가 원하는 신혼가구, 침실가구, 거실가구, 오피스 가구 만 고르고 견적받으세요!"/>*/}
                {/*<meta property="og:image" content="https://www.odgagu.co.kr/assets/images/common/odgagu_common_thumbnail2.jpg"/>*/}

                {/*<meta name="viewport" content="width=device-width, initial-scale=1" />*/}
                {/*<meta name="theme-color" content="#000000" />*/}

                {/*<meta name="google-site-verification" content="URrn0HgaluRVlOx9FM3_1ovjaH6NuPCELtsAlRNyQDQ" />*/}
                {/*<meta name="naver-site-verification" content="9dcd85059c44302a36e828d070b15021af938baa" />*/}

                {/*<link rel="icon" href="/favicon.ico" />*/}
                {/*<link rel="apple-touch-icon" href="/favicon.ico" />*/}
                {/*<link rel="manifest" href="/manifest.json" />*/}
                {/*<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.14.0/css/all.min.css"/>*/}
                {/*<link rel="stylesheet" href="/assets/lib/slick/slick.css"></link>*/}
                {/*<link rel="stylesheet" href="/assets/css/style.css?v=1.0.0"></link>*/}
                {/*<link href="https://fonts.googleapis.com/css?family=Montserrat:300,400,500,700&display=swap" rel="stylesheet"/>*/}
            </Helmet>
            <Switch>
                <Route exact path="/" component={Home} />
                <Route path="/login" component={SiLogin} />
                <Route path="/es" component={Estimate} />
                {/* <Route path="/esapply" component={EsApply} /> */}
                <Route path="/register" component={SuSignup} />
                <Route path="/ct/:code?" component={Category} />
                <Route path="/mysetting" component={MySetting} />
                <Route path="/prod" component={ProductDetail} />
                <Route path="/prod2" component={ProductDetail2} />
                <Route path="/mycart" component={SrMyCart} />
                <Route path="/st" component={SpaceMain} />
                <Route path="/stdetail" component={SpaceDetail} />
                <Route path="/br" component={BrandMain} />
                <Route path="/brHome/:brandId/:code?" component={BrandHome} />
                <Route path="/resetpw" component={SiResetPasswd} />
                <Route path="/findid" component={SiFindId} />
                <Route path='/consult' component={ConsultMain} />
                <Route path='/notice' component={NoticeMain} />
                <Route path='/faq' component={FaqMain} />
                <Route path='/search' component={SearchProd} />
                <Route path='/searchBrand' component={SearchMain} />
                <Route path='/myquestion' component={MyQuestion} />
                <Route path="/myclip" component={MyClip} />
                <Route path="/notfound" component={ErrorMain} />
                <Route path="/order" component={EsOrderMulti} />
                <Route path="/orderdone" component={EsOrderDoneMulti} />
                <Route path="/info/admin/msg" component={SiInfo} />
                <Route path="/mydrop" component={MyDrop} />
                <Route path="/campaign/:type/:id" component={CampaignHome} />
                {/*<Route path="/events" component={CampaignList} />*/}
                <Route path="/event/:id" component={EventDetail} />
                <Route path="/em" component={EventMain} />
                <Route path="/requestform" component={RequestForm} />
                <Route path="/esinfo" component={EstimateInfoView} />
                <Route path="/esdoneinfo" component={EstimateDoneInfoView} />
                <Route path="/estimate/step1" component={EstimateStep1} />
                <Route path="/estimate/step2" component={EstimateStep2} />
                <Route path="/estimate/step3" component={EstimateStep4} />
                <Route path="/estimate/step4" component={EstimateStep5} />
                {/* <Route path="/estimate/step5" component={EstimateStep5} /> */}
                <Route path='*' component={ErrorMain} />
            </Switch>
        </>
    );
};


export default App;
